export const MESSAGES = {
  FOLDERS_LOADING_ERROR: "Failed to load folders.",
  SOMETHING_WENT_WRONG_ERROR: "Something went wrong while loading folders.",
  FILE_UPLOADED: "File uploaded successfully!",
  FILE_UPLOAD_FAILED: "Failed to upload file.",
  FOLDER_CREATED: "Folder created Successfully!",
  FOLDER_CREATION_FAILED: "Failed to create folder",
  FILE_DOWNLOAD_FAILED: "Failed to download file.",
  FILE_DOWNLOAD_SUCCESS: "File downloaded successfully!",
  FAIL_TO_FETCH_FILE: "Failed to fetch file.",
  FOLDER_ACCESS_ADDED: "Changes Saved",
  FOLDER_ACCESS_ADD_FAIL: "Failed to save changes",
  FAILED_LOAD_MY_DRIVE: "Failed to load My drive",
  FAILED_LOAD_SHARED_DRIVE: "Failed to load Shared drive",
  ADD_PARENT_FOLDER: "Please add parent folder",
  USER_FETCH_FAIL: "Failed to load users",
};

export const FOLDER_TYPES = {
  MY: "my",
  SHARED: "shared",
};
